import { BrowserRouter, Route, Routes } from "react-router-dom";

import AppBody from "components/AppBody";
import LoginSplash from "components/LoginSplash";
import ShareBody from "components/ShareBody";
import NotFound404 from "components/404NotFound";
import Home from "components/Home";
import AppLayout from "components/AppLayout";
import PrivateRoute from "components/PrivateRoute";
import AppProviders from "components/AppProviders";

function App() {
  return (
    <BrowserRouter>
      <AppProviders>
        <AppLayout>
          <Routes>
            <Route path="/login" element={<LoginSplash />} />
            <Route path="/share/run/:runId" element={<ShareBody />} />
            <Route
              path="/project/:projectId/:type?"
              element={
                <PrivateRoute>
                  <AppBody />
                </PrivateRoute>
              }
            />
            <Route
              path="/viewer/project/:projectId/:type?"
              element={<AppBody />}
            />
            <Route
              path="/viewer/simulation/:runId/:type?"
              element={<AppBody />}
            />
            <Route
              path="/simulation/:simulationId"
              element={
                <PrivateRoute>
                  <AppBody />
                </PrivateRoute>
              }
            />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Home />
                </PrivateRoute>
              }
            />
            <Route
              path="/customer/:customerId?"
              element={
                <PrivateRoute>
                  <Home />
                </PrivateRoute>
              }
            />
            <Route path="*" element={<NotFound404 />} />
          </Routes>
        </AppLayout>
      </AppProviders>
    </BrowserRouter>
  );
}

export default App;
